const MedicalJourney = () => {
    const steps = [
        "ONLINE CONSULTATIONS",
        "VISA & TRAVEL",
        "ACCOMMODATIONS & AMENITIES",
        "SURGERY & RECOVERY",
        "DISCHARGE & DEPARTURE",
        "GOING BACK TO HOME",
    ];

    return (
        <>
        <section className="int_medical_journey py-5">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h2 className="section-title text-capitalize" data-sal="slide-up" data-sal-duration="1000">Plan Your Medical Journey with Ease</h2>
                    </div>
                    <div className="col-12">
                        <div className="roadmap-container">
                            <div className="roadmap-line">
                                {steps.map((step, index) => {
                                    const isSmallText =
                                    step === "ONLINE CONSULTATIONS" ||
                                    step === "ACCOMMODATIONS & AMENITIES";
                                    
                                    return (
                                        <div
                                        className={`roadmap-step ${index % 2 === 0 ? "top" : "bottom"}`}
                                        key={index}  data-sal="slide-up" data-sal-duration="1000" data-sal-delay={`${index * 100}`}
                                        >
                                            <div className={`circle ${isSmallText ? "small-text" : ""}`}>
                                                <p
                                                    dangerouslySetInnerHTML={{
                                                        __html: step.replace("&", "<br />&<br />"),
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            <img
                                className="plane-icon"
                                src="/assets/img/medical_journey_icon.png"
                                alt="plane-icon"
                            />
                            <div className="helpdesk-btn" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="100">Speak to International Help Desk</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="py-5 mt-5">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="int_features_wrapper">
                            <div className="row">
                                <div className="col-lg-3 d-flex justify-content-center" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="100">
                                    <div className="int_features_item">
                                        <div className="int_features_img_wrapper">
                                            <img src="/assets/img/int_features_01.webp" alt="feature_img" className="img-fluid" />
                                        </div>
                                        <h5>Infrastructure</h5>
                                        <p>Our Hospital provides patients with access to advanced treatments, cutting-edge technology, and world-class clinical care. </p>
                                    </div>
                                </div>
                                <div className="col-lg-3 d-flex justify-content-center" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="200">
                                    <div className="int_features_item">
                                        <div className="int_features_img_wrapper">
                                            <img src="/assets/img/int_features_02.webp" alt="feature_img" className="img-fluid" />
                                        </div>
                                        <h5>STRICT REGULATIONS</h5>
                                        <p>Lifeline Hospital adheres to strict medical regulations, ensuring the highest standards of safety, quality, and patient care. </p>
                                    </div>
                                </div>
                                <div className="col-lg-3 d-flex justify-content-center" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300">
                                    <div className="int_features_item">
                                        <div className="int_features_img_wrapper">
                                            <img src="/assets/img/int_features_03.webp" alt="feature_img" className="img-fluid" />
                                        </div>
                                        <h5>foods</h5>
                                        <p>We offer a variety of nutritious and culturally diverse meals tailored to meet the dietary preferences of our international patients.</p>
                                    </div>
                                </div>
                                <div className="col-lg-3 d-flex justify-content-center" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="400">
                                    <div className="int_features_item">
                                        <div className="int_features_img_wrapper">
                                            <img src="/assets/img/int_features_04.webp" alt="feature_img" className="img-fluid" />
                                        </div>
                                        <h5>INFECTION CONTROL</h5>
                                        <p>Lifeline Hospital follows strict infection control protocols to ensure a safe and sterile environment for international patients. </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    );
};

export default MedicalJourney;
